<template>
  <div id="grid">
    <main>
      <canvas ref="canvas" width="673" height="940"></canvas>
    </main>
    <aside>
      <div>
      <fieldset>
        <legend>Character</legend>
        <div>
          <label for="name">Name</label>
          <input type="text" v-model="name" id="name" @keyup="redraw" />
        </div>
        <div>
          <label for="title">Title</label>
          <input type="text" v-model="title" id="title" @keyup="redraw" />
        </div>
        <div>
          <label for="avatar">Avatar</label>
          <input type="file" ref="avatarInput" id="avatar" @change="updateAvatarData" />
        </div>
        <div>
          <cropper
            :src="avatarData"
            classname="cropper"
            :stencilProps="{
              aspectRatio: 571/419
            }"
            @change="cropChanged"
          ></cropper>
        </div>
      </fieldset>
      <fieldset>
        <legend><button class="small" @click="alter('group1')">&#x270E;</button> {{ group1 }} <span class="counter">({{ timeFree}} Points available)</span></legend>
        <div>
          <label for="fighting" :title="entry11"><button class="small" @click="alter('entry11')">&#x270E;</button> {{ entry11 }}</label>
          <input type="number" v-model="time.fighting" id="fighting" min="0" :max="Math.min(Number(time.fighting) + timeFree, 10)">
        </div>
        <div>
          <label for="crafting" :title="entry12"><button class="small" @click="alter('entry12')">&#x270E;</button> {{ entry12 }}</label>
          <input type="number" v-model="time.crafting" id="crafting" min="0" :max="Math.min(Number(time.crafting) + timeFree, 10)">
        </div>
        <div>
          <label for="leadership" :title="entry13"><button class="small" @click="alter('entry13')">&#x270E;</button> {{ entry13 }}</label>
          <input type="number" v-model="time.leadership" id="leadership" min="0" :max="Math.min(Number(time.leadership) + timeFree, 10)">
        </div>
      </fieldset>
      <fieldset>
        <legend><button class="small" @click="alter('group2')">&#x270E;</button> {{ group2 }}  <span class="counter">({{ scaleFree }} Points available)</span></legend>
        <div>
          <label for="small" :title="entry21"><button class="small" @click="alter('entry21')">&#x270E;</button> {{ entry21 }}</label>
          <input type="number" v-model="scale.small" id="small" min="0" :max="Math.min(Number(scale.small) + scaleFree, 10)">
        </div>
        <div>
          <label for="medium" :title="entry22"><button class="small" @click="alter('entry22')">&#x270E;</button> {{ entry22 }}</label>
          <input type="number" v-model="scale.medium" id="medium" min="0" :max="Math.min(Number(scale.medium) + scaleFree, 10)">
        </div>
        <div>
          <label for="large" :title="entry23"><button class="small" @click="alter('entry23')">&#x270E;</button> {{ entry23 }}</label>
          <input type="number" v-model="scale.large" id="large" min="0" :max="Math.min(Number(scale.large) + scaleFree, 10)">
        </div>
      </fieldset>
      <fieldset>
        <legend><button class="small" @click="alter('group3')">&#x270E;</button> {{ group3 }}  <span class="counter">({{ areaFree }} Points available)</span></legend>
        <div>
          <label for="high" :title="entry31"><button class="small" @click="alter('entry31')">&#x270E;</button> {{ entry31 }}</label>
          <input type="number" v-model="area.high" id="high" min="0" :max="Math.min(Number(area.high) + areaFree, 10)">
        </div>
        <div>
          <label for="low" :title="entry32"><button class="small" @click="alter('entry32')">&#x270E;</button> {{ entry32 }}</label>
          <input type="number" v-model="area.low" id="low" min="0" :max="Math.min(Number(area.low) + areaFree, 10)">
        </div>
        <div>
          <label for="null" :title="entry33"><button class="small" @click="alter('entry33')">&#x270E;</button> {{ entry33 }}</label>
          <input type="number" v-model="area.null" id="null" min="0" :max="Math.min(Number(area.null) + areaFree, 10)">
        </div>
        <div>
          <label for="wh"  :title="entry34"><button class="small" @click="alter('entry34')">&#x270E;</button> {{ entry34 }}</label>
          <input type="number" v-model="area.wh" id="wh" min="0" :max="Math.min(Number(area.wh) + areaFree, 10)">
        </div>
      </fieldset>
      <fieldset class="no-border">
        <div>
          <button type="button" @click="save">Save</button>
        </div>
      </fieldset>
      </div>
    </aside>
    <footer></footer>
  </div>
</template>

<script>
import { Cropper } from "vue-advanced-cropper";
import { saveAs } from "file-saver";

export default {
  name: "home",
  data() {
    return {
      templateImg: null,
      canvasCtx: null,
      name: "",
      title: "",
      avatarData: "",
      avatarImage: new Image(),
      cropCoordinates: null,
      group1: "Time spent on",
      entry11: "Fighting",
      entry12: "Theorycrafting",
      entry13: "Leadership",
      group2: "Scale of operation",
      entry21: "Small Scale",
      entry22: "Medium Scale",
      entry23: "Large Scale",
      group3: "Area of operation",
      entry31: "Highsec",
      entry32: "Lowsec",
      entry33: "Nullsec",
      entry34: "Wormhole",
      time: {
        fighting: 0,
        crafting: 0,
        leadership: 0,
      },
      scale: {
        small: 0,
        medium: 0,
        large: 0
      },
      area: {
        high: 0,
        low: 0,
        null: 0,
        wh: 0
      }
    };
  },
  computed: {
    timeFree() {
      return 15 - this.time.fighting - this.time.crafting - this.time.leadership;
    },
    scaleFree() {
      return 15 - this.scale.small - this.scale.medium - this.scale.large;
    },
    areaFree() {
      return 15 - this.area.high - this.area.low - this.area.null - this.area.wh;
    }
  },
  watch: {
    time: {
      deep: true,
      handler() {
        this.redraw();
      }
    },
    scale: {
      deep: true,
      handler() {
        this.redraw();
      }
    },
    area: {
      deep: true,
      handler() {
        this.redraw();
      }
    }
  },
  methods: {
    redraw() {
      this.canvasCtx.textAlign = "left";
      this.canvasCtx.drawImage(this.templateImg, 0, 0);
      this.canvasCtx.fillStyle = "white";
      this.canvasCtx.font = "bold 36px Rajdhani, sans-serif";
      this.canvasCtx.fillText(this.name, 60, 88);
      this.canvasCtx.font = "bold 24px Rajdhani, sans-serif";
      this.canvasCtx.fillText(this.title, 60, 564);
      this.canvasCtx.font = "bold 21px Rajdhani, sans-serif";
      this.canvasCtx.textAlign = "center";
      this.canvasCtx.fillText(this.group1, 218, 614);
      this.canvasCtx.fillText(this.group2, 448, 614);
      this.canvasCtx.fillText(this.group3, 335, 772);
      this.canvasCtx.textAlign = "left";
      this.canvasCtx.font = "bold 18px Rajdhani, sans-serif";
      this.canvasCtx.fillText(this.entry11, 122, 637);
      this.canvasCtx.fillText(this.entry12, 122, 677);
      this.canvasCtx.fillText(this.entry13, 122, 717);
      this.canvasCtx.fillText(this.entry21, 352, 638);
      this.canvasCtx.fillText(this.entry22, 352, 678);
      this.canvasCtx.fillText(this.entry23, 352, 718);
      this.canvasCtx.font = "bold 18px Rajdhani, sans-serif";
      this.canvasCtx.textAlign = "center";
      this.canvasCtx.fillText(this.entry31, 230, 794);
      this.canvasCtx.fillText(this.entry32, 440, 794);
      this.canvasCtx.fillText(this.entry33, 230, 834);
      this.canvasCtx.fillText(this.entry34, 440, 834);
      if (this.cropCoordinates) {
        this.canvasCtx.drawImage(
          this.avatarImage,
          this.cropCoordinates.left,
          this.cropCoordinates.top,
          this.cropCoordinates.width,
          this.cropCoordinates.height,
          50,
          107 ,
          570,
          418,
        );
      }
      for (let i = 0; i < Math.min(this.time.fighting, 10); i++) {
        this.canvasCtx.beginPath();
        this.canvasCtx.rect(123 + 20 * i, 644, 15, 15);
        this.canvasCtx.fill();
      }
      for (let i = 0; i < Math.min(this.time.crafting, 10); i++) {
        this.canvasCtx.beginPath();
        this.canvasCtx.rect(123 + 20 * i, 684, 15, 15);
        this.canvasCtx.fill();
      }
      for (let i = 0; i < Math.min(this.time.leadership, 10); i++) {
        this.canvasCtx.beginPath();
        this.canvasCtx.rect(123 + 20 * i, 724, 15, 15);
        this.canvasCtx.fill();
      }
      for (let i = 0; i < Math.min(this.scale.small, 10); i++) {
        this.canvasCtx.beginPath();
        this.canvasCtx.rect(353 + 20 * i, 644, 15, 15);
        this.canvasCtx.fill();
      }
      for (let i = 0; i < Math.min(this.scale.medium, 10); i++) {
        this.canvasCtx.beginPath();
        this.canvasCtx.rect(353 + 20 * i, 684, 15, 15);
        this.canvasCtx.fill();
      }
      for (let i = 0; i < Math.min(this.scale.large, 10); i++) {
        this.canvasCtx.beginPath();
        this.canvasCtx.rect(353 + 20 * i, 724, 15, 15);
        this.canvasCtx.fill();
      }
      for (let i = 0; i < Math.min(this.area.high, 10); i++) {
        this.canvasCtx.beginPath();
        this.canvasCtx.rect(133 + 20 * i, 799, 15, 15);
        this.canvasCtx.fill();
      }
      for (let i = 0; i < Math.min(this.area.low, 10); i++) {
        this.canvasCtx.beginPath();
        this.canvasCtx.rect(342 + 20 * i, 799, 15, 15);
        this.canvasCtx.fill();
      }
      for (let i = 0; i < Math.min(this.area.null, 10); i++) {
        this.canvasCtx.beginPath();
        this.canvasCtx.rect(133 + 20 * i, 840, 15, 15);
        this.canvasCtx.fill();
      }
      for (let i = 0; i < Math.min(this.area.wh, 10); i++) {
        this.canvasCtx.beginPath();
        this.canvasCtx.rect(342 + 20 * i, 840, 15, 15);
        this.canvasCtx.fill();
      }
    },
    updateAvatarData() {
      const reader = new FileReader();
      reader.readAsDataURL(this.$refs.avatarInput.files[0]);
      reader.onload = () => {
        this.avatarData = reader.result;
        this.avatarImage.src = this.avatarData;
      }
    },
    cropChanged({coordinates}) {
      this.cropCoordinates = coordinates;
      this.redraw();
    },
    save() {
      this.$refs.canvas.toBlob(function(blob) {
        saveAs(blob, "card.png");
      })
    },
    alter(key) {
      const res = prompt('Rename', this[key]);
      if (res != null) {
        this[key] = res;
      }
      this.redraw();
    }
  },
  components: {
    Cropper
  },
  mounted() {
    this.templateImg = document.createElement("img");
    this.templateImg.src = require("@/assets/eve_card_clean.png");
    this.templateImg.style.display = "none";
    document.body.appendChild(this.templateImg);

    this.canvasCtx = this.$refs.canvas.getContext("2d");

    this.templateImg.addEventListener("load", () => {
      this.redraw();
    });
  }
};
</script>

<style>
#grid {
  min-height: 100%;
  display: grid;
}

aside {
  padding: 1em;
  box-sizing: border-box;
}

main > canvas {
  margin: 0 auto;
  padding-left: 0;
  padding-right: 0;
  margin-left: auto;
  margin-right: auto;
  display: block;
  width: 673px;
}

aside > div {
  padding: 0.1em;
  background: #171718;
  border: 1px solid #2c2a28;
}

legend {
  background: #554237;
  font-weight: 300;
  padding: 0.2em;
  width: 100%;
  box-sizing: border-box;
  line-height: 1.2;
}

fieldset {
  margin-bottom: 2px;
  border: 1px solid #212120;
}

fieldset > div {
  background: #17191a;
  padding: 0.2em;
  width: 100%;
  box-sizing: border-box;
}

label {
  display: inline-block;
  width: 150px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

input[type=text].transparent {
  width: 100%;
  max-width: 150px;
  box-sizing: border-box;
  background-color: transparent;
  border: 1px solid transparent;
  font-family: 'Rajdhani', sans-serif;
  font-size: 16px;
  padding: 0 0.1em;
}

input:hover,
input:focus,
input[type=text].transparent:hover,
input[type=text].transparent:focus {
  border: 1px solid white;
  outline: none;
}


.counter {
  display: inline-block;
  text-align: right;
  font-weight: 400;
  color: rgba(255,255,255, 0.5);
}

.no-border {
  border: none;
}

input {
  background: #000;
  color: #fff;
  border: 1px solid #000;
  min-width: 100px;
  font-family: 'Rajdhani', sans-serif;
  font-size: 16px;
  padding: 0 0.1em;
}

input[type=text],
input[type=file] {
  width: 300px;
  vertical-align: bottom;
}

input[type=number] {
  text-align: right;
  vertical-align: text-top;
  vertical-align: bottom;
}

input[type=number]::-webkit-inner-spin-button {
  opacity: 1;
  margin-left: 0.3em;
}

button {
  padding: 0.5em 1em;
  text-transform: uppercase;
  font-weight: bold;
  background: #342720;
  color: #ccb1a1;
  border: 1px solid #4b362a;
  cursor: pointer;
}

button.small {
  padding: 0.1em 0.2em;
}

.cropper {
    width: 350px;
    box-sizing: border-box;
  }


@media (max-width: 780px) {
  main > canvas {
    width: calc(100vw - 1em);
    height: calc(140vw - 1em);
  }
  aside {
    padding: 0em;
    box-sizing: border-box;
  }
}

@media (min-width: 1100px) {
  .cropper {
    width: 500px;
    box-sizing: border-box;
  }

  #grid {
    grid-template-columns: 5fr 7fr 1fr;
    grid-template-rows: auto 25px;
  }

  main {
    grid-column: 2 / 3;
    grid-row: 1 / 2;

    margin-top: 1em;

    height: 100%;
  }

  aside {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
  }

  footer {
    grid-column: 1 / 6;
    grid-row: 2 / 3;

    height: 100%;
  }
}

@media (min-width: 1600px) {
  #grid {
    grid-template-columns: 5fr 1fr 7fr 1fr 5fr;
    grid-template-rows: auto 25px;
  }

  main {
    grid-column: 3 / 4;
  }
}
</style>
